// Foundation JavaScript
// Documentation can be found at: http://foundation.zurb.com/docs
$(document).foundation();

// document ready method
$(function () {
  $("html, body").scrollTop(0);

  // check if this is IE
  function getIEVersion() {
    var sAgent = window.navigator.userAgent;
    var Idx = sAgent.indexOf("MSIE");
    // If IE, return version number.
    if (Idx > 0) {
      return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));
    } else if (!!navigator.userAgent.match(/Trident\/7\./)) {
      // If IE 11 then look for Updated user agent string.
      return 11;
    } else {
      return 0; //It is not IE
    }
  }

  sal({
    once: true,
  });

  const $body = $("body");

  /**
   * Selector for Categories on the BLOG PAGE
   */

  const filtersContainer = document.getElementById("filters-container");
  if (filtersContainer) {
    let container = filtersContainer.querySelector(".filters-for-medium"),
      containerWidth,
      filterItems = container.querySelectorAll(".filters-buttons"),
      extraMarkup = `
      <div id="filters-extra-container">
        <button class="filters-trigger" type="button" data-toggle="filter-extra-content"><span>...</span></button>
        <div id="filter-extra-content" class="dropdown-pane" data-dropdown data-hover="true" data-hover-pane="true"></div>
      </div>`,
      extraContent = false,
      extraContainer = false,
      filterWidths = [];
    function doFilters() {
      containerWidth =
        container.clientWidth -
        (extraContainer ? extraContainer.clientWidth + 4 : 30); // the maximimum some space for the dropdown trigger; substract the width of the extracontainer, if visible (+4px for spacing)
      let maxWidth = 0,
        i,
        len = filterItems.length;
      // let's calculate which items will be shown
      for (i = 0; i < len; i++) {
        let width = filterItems[i].clientWidth;
        // we store the widths into an array, to be used when elements are hidden and their width becomes = 0
        if (width > 0) {
          filterWidths[i] = width;
        } else {
          width = filterWidths[i];
        }
        if (width + maxWidth > containerWidth) {
          break;
        } else {
          maxWidth += width;
          filterItems[i].classList.remove("hide");
        }
      }
      // move the extra elements into the dropdown
      if (i < len) {
        // first time initialization of the dropdown
        if (!extraContainer) {
          container.insertAdjacentHTML("beforeend", extraMarkup);
          extraContent = document.getElementById("filter-extra-content");
          extraContainer = document.getElementById("filters-extra-container");
          $(extraContainer).foundation();
        }
        // we add the extra elements to the filter container
        let extraContentHTML = "",
          maxElements = i;
        for (let i = maxElements; i < len; i++) {
          extraContentHTML += filterItems[i].outerHTML;
          filterItems[i].classList.add("hide");
        }
        extraContent.innerHTML = extraContentHTML;
        extraContent
          .querySelectorAll(".filters-buttons")
          .forEach((item) => item.classList.remove("hide"));
      } else {
        // delete the extra container with the markup
        if (extraContainer) {
          extraContainer.remove();
          extraContainer = false;
          extraContent = false;
        }
      }
    }
    window.addEventListener("resize", doFilters);
    doFilters();

    // the mobile filters selector
    const mobileFilters = document.getElementById("filters-for-small");
    if (mobileFilters !== null) {
      mobileFilters.addEventListener("change", function (e) {
        if (this.selectedOptions) {
          let selectedCat = [],
            url = mobileFilters.dataset.href;
          for (let i = 0, len = this.selectedOptions.length; i < len; i++) {
            if (this.selectedOptions[i].value != "") {
              selectedCat.push(this.selectedOptions[i].value);
            } else if (len >= 2) {
              // if this is the "Tous" option and there is another option selected as well, deselect this one
              this.selectedOptions[i].selected = false;
            }
          }
          // go to the new URL if it's different to the current one
          const newUrl = url + "=" + selectedCat.join(",");
          if (
            window.location.origin + newUrl != window.location.href &&
            newUrl != window.location.href
          ) {
            // double check, because in our themes we echo the URLs without the domain name
            window.location.href = newUrl;
          }
        }
      });
    }
  }

  $(".contact-child > a").attr("id", "gtm-clic-nous-contacter");

  // newsletter checkboxes
  function showNewsletterCheckboxes() {
    $("#field_1_2").css("display", "inline").fadeIn(2000);
    $("#field_1_3").css("display", "inline").fadeIn(2000);
    $("#field_1_4").css("display", "inline").fadeIn(2000);
  }

  $("#input_1_1").focus(function () {
    // console.log('input1')
    showNewsletterCheckboxes();
    // $("#field_1_5").css("display", "inline").fadeIn(2000);
    $("html, body").animate(
      { scrollTop: $(document).height() },
      1500,
      "linear"
    );
    return false;
  });

  setTimeout(() => {
    $(document).on("gform_post_render", function () {
      showNewsletterCheckboxes();
    });
  }, 1000);

  // click on menu for submenu
  var $closingBodyMenu = null;
  let $headerMenu = $(".header-menu-bottom");
  $headerMenu
    .on("closeMenu", function () {
      // a close menu event
      $headerMenu.find("li.active").removeClass("active");
      $body.removeClass("noscroll main-menu-opened");
      $headerMenu.removeClass("is-opened");
    })
    .on("click", "> li", function (e) {
      // listen to clicks
      const $this = $(this);
      let isOpened = false;
      if (
        $this.hasClass("menu-item-has-children") ||
        $this.hasClass("search-item")
      ) {
        // activate only if inactive
        if (!$this.hasClass("active")) {
          e.preventDefault();
          if ($closingBodyMenu) clearInterval($closingBodyMenu);

          isOpened = true;
          $body.addClass("noscroll main-menu-opened");
          $headerMenu.find("li.active").not($this).removeClass("active");
          $this.addClass("active");
          $headerMenu.addClass("is-opened");
        }
      }
      // if this didn't trigger an open event, close the menus
      if (!isOpened) {
        $headerMenu.trigger("closeMenu");
      }
      // console.log($(this).attr('class'));
    })
    .on("click", "> li > a", function (e) {
      const $parent = $(this).parent();
      if (
        $parent.hasClass("menu-item-has-children") ||
        $parent.hasClass("search-item")
      ) {
        // allow clicks to go through when are already in this same menu
        if (!$parent.hasClass("active")) {
          e.preventDefault();
        }
      }
    });
  // close the menu when we click somewhere else, outside the menu
  $(document).on("click", "body.main-menu-opened", function (e) {
    // is our click outside the menu?
    if (!$.contains($headerMenu[0], e.target)) {
      e.stopPropagation();
      e.preventDefault();
      $headerMenu.trigger("closeMenu");
    }
  });

  $(".espace-client > a").attr("id", "click-espace-client");

  // SLIDER-NEWS
  $(".slider-news").chLazySlick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    mobileFirst: true,
    centerMode: true,
    centerPadding: "40px",
    autoplay: false,

    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          autoplay: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          dots: false,
          centerMode: false,
          centerPadding: 0,
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 5,
          centerMode: false,
          centerPadding: 0,
          autoplay: true,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  // SLIDER-PARTNERS
  $(".slider-partners").chLazySlick({
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite: true,
    autoplay: false,

    responsive: [
      {
        breakpoint: 2800,
        settings: {
          slidesToShow: 5,
          dots: false,
        },
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 4,
          dots: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          dots: false,
          centerMode: false,
          centerMode: true,
          centerPadding: "40px",
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "40px",
          dots: true,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  // SLIDER-TITLES
  $(".slider-titles")
    .chLazySlick({
      arrows: false,
      asNavFor: ".slider-articles",
      focusOnSelect: true,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: true,
    })
    .on("setPosition", function (slick) {
      $(this).find(".slick-track").css("transform", "translate3d(0,0,0)");
      //console.log($(this).find('.slick-track'));
      // console.log(slick);
      // console.log(breakpoint);
    });

  // SLIDER-ARTICLES
  $(".slider-articles").chLazySlick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    asNavFor: ".slider-titles",
    mobileFirst: true,
    centerMode: true,
    centerPadding: "20px",
    // speed: 300,
    fade: true,
    cssEase: "ease-in-out",
    pauseOnHover: true,
    autoplay: true,
    autoplaySpeed: 3000,
    focusOnSelect: true,

    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          centerPadding: "20px",
          centerPadding: 0,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          dots: false,
          centerMode: false,
          centerPadding: 0,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  // SLIDER-TILES
  $(".tiles-slider").chLazySlick({
    slidesToShow: 1,
    arrows: false,
    dots: true,
    infinite: true,

    responsive: [
      {
        breakpoint: 3500,
        settings: "unslick",
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
          centerMode: true,
          centerPadding: "40px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "40px",
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  // SLIDER-OFFRE-ARTICLES
  $(".offre-slider-nav")
    .chLazySlick({
      arrows: true,
      asNavFor: ".offre-slider",
      focusOnSelect: true,
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      centerMode: true,
    })
    .on("setPosition", function (slick) {
      $(this).find(".slick-track").css("transform", "translate3d(0,0,0)");
      //console.log($(this).find('.slick-track'));
      // console.log(slick);
      // console.log(breakpoint);
    });

  $(".offre-slider").chLazySlick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    mobileFirst: true,
    centerMode: true,
    centerPadding: "20px",
    asNavFor: ".offre-slider-nav",
    fade: true,
    cssEase: "ease-in-out",
    pauseOnHover: true,
    autoplay: true,
    autoplaySpeed: 3000,
    focusOnSelect: true,

    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
          centerMode: false,
          centerPadding: "0px",
          fade: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          dots: false,
          centerMode: false,
          centerPadding: "0px",
          fade: true,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  // SLIDER_NEWS
  $(".news-slider").chLazySlick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    autoplay: true,
    centerMode: true,
    centerPadding: "40px",
    autoplaySpeed: 2000,
    speed: 500,
    mobileFirst: true,

    responsive: [
      {
        breakpoint: 767,
        settings: {
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "40px",
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  // carriers SLIDER

  $(".slider-titles-carriers")
    .chLazySlick({
      arrows: false,
      asNavFor: ".slider-articles-carriers",
      focusOnSelect: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: false,
    })
    .on("setPosition", function (slick) {
      $(this).find(".slick-track").css("transform", "translate3d(0,0,0)");
      //console.log($(this).find('.slick-track'));
      // console.log(slick);
      // console.log(breakpoint);
    });

  $(".slider-articles-carriers")
    .chLazySlick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      mobileFirst: true,
      centerMode: true,
      centerPadding: "20px",
      asNavFor: ".slider-titles-carriers",
      fade: true,
      cssEase: "ease-in-out",
      pauseOnHover: true,
      // autoplay: true,
      autoplaySpeed: 3000,
      focusOnSelect: true,

      responsive: [
        {
          breakpoint: 768,
          settings: {
            dots: true,
            // centerMode: true,
            // centerPadding: '20px',
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            dots: false,
            centerMode: false,
            centerPadding: "0px",
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    })
    .animateOnScroll({
      // do this when the object is in view
      callback: function (slider) {
        // slider = the current element
        console.log("Slider ", slider, " is in view");
        $(slider).slick("slickPlay");
        console.log($(slider).slick("slickGetOption", "autoplay"));
      },
    });

  $(".slider-titles-event")
    .chLazySlick({
      arrows: false,
      asNavFor: ".slider-articles-events",
      focusOnSelect: true,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: true,
    })
    .on("setPosition", function (slick) {
      $(this).find(".slick-track").css("transform", "translate3d(0,0,0)");
      //console.log($(this).find('.slick-track'));
      // console.log(slick);
      // console.log(breakpoint);
    });

  $(".slider-articles-events").chLazySlick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    asNavFor: ".slider-titles-event",
    mobileFirst: true,
    centerMode: true,
    centerPadding: "20px",
    // speed: 300,
    fade: true,
    cssEase: "ease-in-out",
    pauseOnHover: true,
    autoplay: true,
    autoplaySpeed: 3000,
    focusOnSelect: true,

    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          centerPadding: "20px",
          centerPadding: 0,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          dots: false,
          centerMode: false,
          centerPadding: 0,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  // TIMELINE SLIDER

  $(".timeline-slider-nav").chLazySlick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    mobileFirst: true,
    centerMode: true,
    centerPadding: "20px",
    asNavFor: ".timeline-slider",
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          focusOnSelect: true,
          infinite: true,
          slidesToShow: 5,
          slidesToScroll: 1,
          // centerMode: true,
        },
      },
    ],
  });

  $(".timeline-slider").chLazySlick({
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    asNavFor: ".timeline-slider-nav",
    // mobileFirst: true,
    infinite: true,
    centerMode: true,
    centerPadding: "0px",
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          // dots: true,
          // centerMode: false,
          // centerPadding: 0,
          fade: true,
        },
      },
    ],
  });

  // REFERENCE SLIDER
  $(".slider-references").chLazySlick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    mobileFirst: true,
    centerMode: true,
    centerPadding: "40px",
    autoplay: false,

    responsive: [
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 2,
          autoplay: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          dots: false,
          centerMode: false,
          centerPadding: 0,
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: false,
        },
      },
    ],
  });

  // TEAM SLIDER

  $(".team-slider")
    .chLazySlick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      // mobileFirst: true,
      infinite: true,
      // autoplay: true,
      // autoplaySpeed: 2000,
      // speed: 500,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            // dots: true,
            centerMode: true,
            centerPadding: "20px",
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 640,
          settings: {
            // dots: true,
            centerMode: true,
            centerPadding: "20px",
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    })
    .animateOnScroll({
      // do this when the object is in view
      callback: function (slider) {
        // slider = the current element
        console.log("Slider ", slider, " is in view");
        $(slider).slick("slickPlay");
        console.log($(slider).slick("slickGetOption", "autoplay"));
      },
    });

  var maps = $(".map");
  if (maps.length) {
    maps.each(function (i, map) {
      render_map($(map));
    });
  }

  // Buttons append to
  if (Foundation.MediaQuery.is("small only")) {
    $(".btn-container").clone().appendTo(".header-content");
  }

  window.chMatchHeight = function () {
    // MATCH-HEIGHT
    $(".js-eh").matchHeight();
    $(".js-eh-1").matchHeight();
    $(".js-eh-2").matchHeight();
    $(".js-eh-3").matchHeight();
    $(".js-eh-4").matchHeight();
    $(".slider-references .slick-slide").matchHeight();

    if (Foundation.MediaQuery.atLeast("medium")) {
      $(".js-eh-row").matchHeight({
        byRow: false,
      });
    }
  };
  chMatchHeight();
  window.addEventListener("load", chMatchHeight);

  // menuTrigger
  $(".menu-trigger").click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    $body.toggleClass("menu-opened");
    $(this).toggleClass("active");
  });

  // MOBILE-MENU-TOP
  if ($(window).width() < 1024) {
    $(".page-header .header-menu-top").clone().appendTo(".nav-wrapper");
  }

  // MOBILE-SUBMENU
  $(".page-header .bkg-white .row.column").prepend(
    '<a href="#!" class="parent-item-close-submenu"></a>'
  );
  /*
	$('.nav-wrapper .header-menu-top li.menu-item-has-children ul').each(function() {
		$(this).prepend('<li class="parent-item"><a href="#!"></a></li>');
		var $parent = $(this).parents('li');
		// $(this).find(' > .parent-item').append( $($parent[0]).find('> a').clone());
	});
*/
  var $opened_menu_item = null;
  $(document).on(
    "click",
    ".nav-wrapper .header-menu-top li.menu-item-has-children > a",
    function (e) {
      e.preventDefault();
      e.stopPropagation();
      const $this = $(this),
        $parent = $(this).parent(),
        $wrapper = $this.closest(".nav-wrapper");
      $parent.toggleClass("opened");
      $parent.find(" ul").toggleClass("opened");
      $body.toggleClass("sub-menu-opened");
      $wrapper[0].scrollTop = 0; // scroll to top to prevent issues on iPhone
      $opened_menu_item = $(this).parent();
    }
  );

  $(document).on("click", "a.parent-item-close-submenu", function (e) {
    console.log($opened_menu_item);
    if ($opened_menu_item) {
      e.preventDefault();
      e.stopPropagation();
      $opened_menu_item.removeClass("opened");
      var ul = $opened_menu_item.find(".ch-subnav.opened");
      console.log(ul);
      if (!ul.length) ul = $opened_menu_item.find("ul.opened");
      if (ul.length) ul.removeClass("opened");

      $body.removeClass("sub-menu-opened");

      $opened_menu_item = null;
    }
  });

  // MOBILE-SUBMENU
  // $('.nav-wrapper .header-menu-bottom li.menu-item-has-children .ch-subnav').each(function() {
  // 	$(this).prepend('<li class="parent-item"><a href="#!"></a></li>');
  // 	// var $parent = $(this).parents('li');
  // 	// $(this).find(' > .parent-item').append( $($parent[0]).find('> a').clone());
  // });

  $(document).on(
    "click",
    ".nav-wrapper .header-menu-bottom li.menu-item-has-children > a",
    function (e) {
      e.preventDefault();
      e.stopPropagation();
      var $p = $(this).parent();
      $p.toggleClass("opened");
      $p.find(" .ch-subnav").toggleClass("opened");
      $body.toggleClass("sub-menu-opened");
      $opened_menu_item = $(this).parent();
    }
  );

  // $(document).on('click', '.nav-wrapper .header-menu-bottom li.parent-item > a', function(e) {
  // 	var $p=$(this).parent().parent().parent();
  // 	e.preventDefault();e.stopPropagation();
  // 	$p.toggleClass('opened');
  // 	$p.find(' .ch-subnav').toggleClass('opened');
  // 	$body.toggleClass('sub-menu-opened');
  // });

  //images footer diagonal

  $(".diagonal-slider li").mouseenter(function (e) {
    if ($(window).width() > 990) {
      $(".current").removeClass("current");
      $(this).addClass("current");
    }
  });

  slickSpecial();
  $(window).on("resize", function () {
    slickSpecial();
  });
  function slickSpecial() {
    if ($(window).width() < 1025) {
      $(".small-slide-only:not(.slick-initialized)").chLazySlick({
        // infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        centerMode: true,
        centerPadding: "40px",
        mobileFirst: true,
      });
    } else if ($(".small-slide-only.slick-initialized")) {
      $(".small-slide-only.slick-initialized").slick("unslick");
    }
  }

  // triggerSearch
  $(".triggerSearch").click(function (e) {
    e.preventDefault();

    $body.toggleClass("search-opened");
    $(this).toggleClass("active");
  });

  // SELECT2
  if ($(".gform_body select").length) {
    $(".gform_body select").select2();

    $(document).on(
      "gform_post_render",
      function (event, form_id, current_page) {
        $(".gform_body select").select2();
      }
    );
  }

  // STICKY HEADER
  var $blockStickyMode = 0;
  $(document).on("scroll", function () {
    if (!$blockStickyMode) {
      setHeaderSticky();
    }
  });
  $body.on("scroll", function () {
    if (!$blockStickyMode) {
      setHeaderSticky();
    }
  });

  setHeaderSticky();

  function setHeaderSticky() {
    var st = $(document).scrollTop();
    if (st == 0) st = $(window).scrollTop();
    // console.log(
    //   '.inner-content' + '::'+$('.inner-content').scrollTop()+
    //   ', .page-container' + '::'+$('.page-container').scrollTop()+
    //   ', .page-content' + '::'+$('.page-content').scrollTop()+
    //   ', body' + '::'+$body.scrollTop()+
    //   ', html' + '::'+$('html').scrollTop()+
    //   ', window' + '::'+$(window).scrollTop()+
    //   ', document' + '::'+$(document).scrollTop());

    if (st > 0) {
      $body.addClass("header-sticky");
      if (st >= $(window).height() - 90) {
        $body.addClass("after-1-screen");
      } else {
        $body.removeClass("after-1-screen");
      }
    } else {
      $body.removeClass("after-1-screen header-sticky");
    }
  }

  // TelechargerTrigger
  $(".telecharger-trigger.tl-trigger").click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    $body.toggleClass("telecharger-opened");
    $(this).toggleClass("active");
  });
  $(".telecharger .tl-link").click(function (e) {
    // e.preventDefault();e.stopPropagation();
    setCookie("n" + cht_wp.ncode, -2, 1); //-2 has opened the form page, if it will leave the form page, it will be visible again
  });
  $(".tl-close.tl-trigger").click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    if ($body.hasClass("telecharger-opened")) {
      setCookie("n" + cht_wp.ncode, -1, 1); //-1 is closed
      // setTimeout(function() {
      // $('.telecharger-trigger.tl-trigger').animate({'opacity':0}, 400);
      // setTimeout(function() {
      // 	$('body > .telecharger').remove();
      // }, 400);
      // }, 600);
    }
    $body.toggleClass("telecharger-opened");
    $(this).toggleClass("active");
  });

  function ch_openTelechargerPopup() {
    if (getCookie("n" + cht_wp.ncode) > -1) {
      $body.addClass("telecharger-opened");
    }
  }

  var _popupOpenedOnFPage = 0;
  setTimeout(function () {
    if ($body.hasClass("page-template-front-page")) {
      $(window).on("scroll", function () {
        if (!_popupOpenedOnFPage) {
          _popupOpenedOnFPage = 1;
          setTimeout(function () {
            ch_openTelechargerPopup();
          }, 1000);
        }
      });
    } else {
      ch_openTelechargerPopup();
    }
  }, 3000);

  // var scrollticker; // - don't need to set this in every scroll

  // $(window).scroll(function() {
  //   // Clear Timeout if one is pending
  //   if(scrollticker) { window.clearTimeout(scrollticker); scrollticker = null; }
  //   // Set Timeout
  //   scrollticker=window.setTimeout(function(){
  //     $body.toggleClass('telecharger-opened'); // what is executed on scroll
  //   }, 3000); // Timeout in msec
  // });

  if (getCookie("n" + cht_wp.ncode) == -2 && $("#gform_wrapper_4").length) {
    setCookie("n" + cht_wp.ncode, 1, 1); //is not closed
  }

  // SCROLL TO NEXT SECTION
  $(".scroll-to-next-section, #click-postes").click(function () {
    var offset = -115; // Offset of -115px

    $("html, body").animate(
      {
        scrollTop: $("#section_scrolled").offset().top + offset,
      },
      1000
    );
  });

  // next section

  $(".js-red-btn:not(.no-arrow)").click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    var t = $(this);
    (url = t.attr("href")),
      (headerHeight = $(".page-header-inner").outerHeight());

    $("body,html")
      .stop()
      .animate({
        scrollTop: $(url).offset().top - headerHeight,
      });
  });

  // MOBILE MENU-FOOTER
  $(document).on(
    "click",
    ".footer-top-nav .header-menu-top .menu-item-has-children > a",
    function (e) {
      if ($(window).width() < 1025) {
        e.preventDefault();
        e.stopPropagation();

        var $p = $(this).parent();
        $p.toggleClass("opened");
        $p.siblings().removeClass("opened");
        $p.find("> ul").toggleClass("opened");
      }
    }
  );

  //file upload

  var input_lbl_before_change = "";
  $(document).on("change", 'input[name="input_20"]', function () {
    var v = $(this).val();
    if (v) {
      var basename = v.replace(/\\/g, "/").replace(/.*\//, ""),
        $lip = $(this).parents("li.file-upload"),
        $lbl = $lip.find("label"),
        $fnlbl = $lbl.find("b");
      if ($fnlbl.length) {
        $lbl.html("<b>" + basename + "</b>");
      } else {
        $lip.append('<a href="#" class="close-btn">x</a>');
        input_lbl_before_change = $lbl.html();
        $lbl.html("<b>" + basename + "</b>");
      }
    } else {
      var $lip = $(this).parents("li.file-upload"),
        $lbl = $lip.find("label");
      $lip.find("a.close-btn").remove();
      $lbl.html(input_lbl_before_change);
    }
  });

  $(document).on("click", "li.file-upload a.close-btn", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('input[name="input_20"]').val("").trigger("change");
  });

  // video
  const $videoIframe = $(".video-iframe-wrapper iframe[data-src]");
  let resize_fluid_interval = null;
  if ($videoIframe.length) {
    // check if we need to start the video
    function checkVideo() {
      if (Foundation.MediaQuery.atLeast("medium")) {
        // console.log('medium-down');
        $videoIframe.each(function () {
          const $this = $(this);
          // load only once
          if ($this.data("loaded") != "true") {
            $this.attr("src", $this.data("src")).data("loaded", "true");
            const parent = this.parentNode;

            // make the iframe transparent, unless we are on IE
            if (!getIEVersion()) parent.classList.add("playback-waiting");
            const player = new Vimeo.Player(this); // using the latest Vimeo API
            // show the player when it's actually started playing
            player.on("play", () =>
              setTimeout(() => {
                parent.classList.remove("playback-waiting");
                parent.classList.add("playback-started");
              }, 50)
            );
          }
        });
      }
    }
    checkVideo();
    $(window).on("changed.zf.mediaquery", checkVideo); // load when moving from small to medium screens
  }

  $videoIframe.each(function () {
    changeVideoAspectRatio($(this));
  });

  $(window).on("resize", function () {
    if (resize_fluid_interval) {
      clearInterval(resize_fluid_interval);
    }
    resize_fluid_interval = setInterval(function () {
      clearInterval(resize_fluid_interval);
      resize_fluid_interval = null;
      changeVideoAspectRatio($videoIframe);
    }, 50);
  });

  function changeVideoAspectRatio($ifr) {
    var vr = 16 / 9,
      wh = $ifr.parent().outerHeight(true),
      ww = $(window).width(),
      $ifrh = "100%",
      $ifrw = "100%",
      $ifrt = 0,
      $ifrl = 0,
      yt_border = 140;
    if (cht_wp.vw) {
      vr = cht_wp.vw / cht_wp.vh;
    }
    // console.log(vr);
    // console.log($ifr.width());
    // console.log($ifr.height());
    if (ww / vr > wh) {
      // console.log('1 '+ww+' / '+wh+' / '+vr);
      $ifrh = ww / vr;
      $ifrt = (-1 * ($ifrh - wh)) / 2;
      $ifrh += yt_border * 2;
      $ifrt -= yt_border;
      $ifrw = "calc(100% + " + yt_border * 2 + "px)";
      $ifrl = -1 * yt_border;
    } else {
      // console.log('2 : '+ww+' / '+wh+' / '+vr);
      // console.log('old vr :: ' + vr);
      if (cht_wp.vw) {
        vr = cht_wp.vw / cht_wp.vh;
      }
      // console.log('new vr :: ' + vr);
      $ifrw = wh * vr;
      $ifrl = (-1 * ($ifrw - ww)) / 2;
      $ifrw += yt_border * 2;
      $ifrl -= yt_border;
      $ifrt = -1 * yt_border;
      $ifrh = "calc(100% + " + yt_border * 2 + "px)";

      // console.log('$ifrw :: ' + $ifrw);
    }

    $ifr.css({ width: $ifrw, height: $ifrh, left: $ifrl, top: $ifrt });

    $ifr.parent().css({
      backgroundSize: $ifrw,
    });
  }

  // open the cookies preferences again
  $(".open-cookies-prefs").on("click", function (e) {
    e.preventDefault();
    if (typeof tarteaucitron != "undefined") {
      tarteaucitron.userInterface.openPanel();
    }
  });

  // animated text

  $("[data-animated-title]").each(function () {
    const $this = $(this),
      sentences = $this.data("animated-title");
    const typed = new Typed(this.querySelector("span"), {
      strings: sentences,
      typeSpeed: 70,
      startDelay: 1200,
      backSpeed: 60,
      backDelay: 500,
      showCursor: true,
      cursorChar: "_",
      smartBackspace: true, // this is a default
      loop: false,
      onComplete: function (self) {
        self.cursor.remove();
      },
    });
  });
});
